import { render } from "./IncomeForm.vue?vue&type=template&id=1823b709"
import script from "./IncomeForm.vue?vue&type=script&lang=js"
export * from "./IncomeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Cards/Forms/IncomeForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1823b709"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1823b709', __exports__)) {
    api.reload('1823b709', __exports__)
  }
  
  module.hot.accept("./IncomeForm.vue?vue&type=template&id=1823b709", () => {
    api.rerender('1823b709', render)
  })

}


export default __exports__